import API from "../utils/api";

// -------------------- Channels --------------------

export const getChannels = () =>
  API.get("teamchat/channels/");

// -------------------- Members (org-wide for Team Chat only; no role filtering) --------------------

export const getTeamChatMembers = () =>
  API.get("teamchat/members/");

// -------------------- Messages --------------------

export const getChannelMessages = (channelId) =>
  API.get(`teamchat/channels/${channelId}/messages/`);

/**
 * @param {number} channelId
 * @param {{ body: string, text?: string, mentions?: number[], reply_to?: object }} payload - body (or text), mentions, optional reply_to (quoted reply)
 */
export const sendChannelMessage = (channelId, payload) =>
  API.post(`teamchat/channels/${channelId}/messages/`, {
    body: payload.body ?? payload.text,
    mentions: payload.mentions ?? [],
    ...(payload.reply_to != null ? { reply_to: payload.reply_to } : {}),
  });

export const deleteChannelMessage = (channelId, messageId) =>
  API.delete(`teamchat/channels/${channelId}/messages/${messageId}/`);
